import React from "react";

export default ({ color, size }) => (
  <svg width={size || 24} height={size || 24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>transfer-left</title>
    <path fill={color} d="M21,16H19V8H21V16M17,16H15V8H17V16M13,16H11V8H13V16M9,5V19L2,12L9,5Z" />
  </svg>
);
